// Allows js errors to fallback to error page to prevent infinite rerender
// Is not yet supported by react hooks
// See https://reactjs.org/docs/error-boundaries.html
import React from 'react';
import Error500 from './Error500';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error) {
    // Update state so the next render will show the fallback UI.
    this.setState({
      error
    });
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return <Error500 />;
    }

    return children;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/components/ErrorBoundary.jsx